import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import * as complianceActions from '../actions/static-data-compliance.actions';
import { IStaticDataResponse } from '../models/static-data.model';

export const staticDataValueRisksFeatureKey = 'staticDataValueRisks';

export interface StaticDataValueRisksState {
  loading: boolean;
  data: IStaticDataResponse[];
  error: any;
}

export const initialState: StaticDataValueRisksState = {
  loading: false,
  data: [],
  error: null
};

export const reducer = createReducer(
  initialState,
  on(complianceActions.loadValueRisks, state => ({ ...state, loading: true, error: null })),
  on(complianceActions.loadValueRisksSuccess, (state, { response }) => ({ ...state, loading: false, data: response, error: null })),
  on(complianceActions.loadValueRisksFailure, (state, { error }) => ({ ...state, loading: false, error }))
);

export const getValueRisks = (state: StaticDataValueRisksState) => state.data;
export const getValueRisksLoading = (state: StaticDataValueRisksState) => state.loading;
export const getValueRisksError = (state: StaticDataValueRisksState) => state.error;